import { useSearch } from '@tanstack/react-router';

export const DUMPSTER_TYPES = [
  'residential',
  'commercial',
  'rolloff',
  'portableToilet',
] as const;

export type DumpsterType = (typeof DUMPSTER_TYPES)[number];

export const getDumpsterType = (value: unknown): DumpsterType => {
  return typeof value === 'string' &&
    DUMPSTER_TYPES.includes(value as DumpsterType)
    ? (value as DumpsterType)
    : 'residential';
};

export const useDumpsterTypeSearch = (): DumpsterType =>
  useSearch({
    strict: false,
    select: (search) => getDumpsterType((search as { type?: unknown }).type),
  });
